<template>
  <div>
    <LayoutHeader
      activeNav="评审专家库"
      :topColor="topColor"
      bannerType="header expert"
      :height="498"
    />
    <div class="container">
      <div class="repeatTitle">
        <div class="title_text art_info_line">
          <h1>资料上传</h1>
          <h2>Data upload</h2>
        </div>
      </div>

      <div
        v-show="userInfo.expert_info.status_apply == undefined"
        class="steps"
      >
        <div style="color: #ffffff">
          上传资料
          <img src="../../assets/images/expert/zjk-schedule1-1.png" alt="" />
        </div>
        <div style="color: #989898">
          平台审核
          <img src="../../assets/images/expert/zjk-schedule3-2.png" alt="" />
        </div>
        <div style="color: #989898">
          资料入库
          <img src="../../assets/images/expert/zjk-schedule3-3.png" alt="" />
        </div>
      </div>

      <div v-show="userInfo.expert_info.status_apply == 0" class="steps">
        <div style="color: #ffffff">
          上传资料
          <img src="../../assets/images/expert/zjk-schedule1-1.png" alt="" />
        </div>
        <div style="color: white">
          平台审核
          <img src="../../assets/images/expert/zjk-schedule2-2.png" alt="" />
        </div>
        <div style="color: #989898">
          资料入库
          <img src="../../assets/images/expert/zjk-schedule3-3.png" alt="" />
        </div>
      </div>
      <div v-show="userInfo.expert_info.status_apply == 1" class="steps">
        <div style="color: #ffffff">
          上传资料
          <img src="../../assets/images/expert/zjk-schedule1-1.png" alt="" />
        </div>
        <div style="color: white">
          平台审核
          <img src="../../assets/images/expert/zjk-schedule1-2.png" alt="" />
        </div>
        <div style="color: white">
          资料入库
          <img src="../../assets/images/expert/zjk-schedule2-3.png" alt="" />
        </div>
      </div>
      <ExpertUploadForm v-if="userInfo.expert_info.id == undefined" />
      <ExpertUploadInfo v-else />
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import UserServices from "../../xx-vue/services/user";
import SystemServices from "../../xx-vue/services/system";
export default {
  data() {
    return {
      topColor: "",
      userInfo: {
        expert_info: {
          id: undefined,
        },
      },
    };
  },
  mounted() {
    this.initScroll();
    this.getUser();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.activeNav = val;
    },
    //获取用户信息
    async getUser() {
      const userInfo = await UserServices.getCurrentUserAsync();
      this.userInfo = userInfo.data;
      console.log(this.userInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 42px 0;

  .repeatTitle {
    display: flex;
    justify-content: center;
    .title_text {
      text-align: center;
      background: url("../../assets/images/index/title-line1@2x.png") no-repeat
        44px 0px;
      background-size: contain;
      padding: 10px;
    }

    h1 {
      font-size: 26px;
      padding-top: 6px;
    }

    h2 {
      font-size: 14px;
      color: #989898;
      font-weight: normal;
    }

    .art_info_line {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2left@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        left: -500px;
        top: 30px;
      }

      &::before {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2right@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        right: -500px;
        top: 30px;
      }
    }
  }

  .steps {
    width: 660px;
    margin: 0 auto;
    display: flex;
    margin-top: 45px;
    margin-bottom: 30px;
    div {
      width: 220px;
      height: 64px;
      position: relative;
      text-align: center;
      line-height: 64px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -2;
      }
    }
  }
}
</style>